import React from "react";
import { NavLink } from "react-router-dom";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";

export class CasinoUtrke extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Moje utrke', 'Informacije'],
            selectedTab: 'Moje utrke',
            races: null
        }

        this.setData = this.setData.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Casino Utrke', '', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user) {
            this.getData()
        }
    }

    addDefaultSrc(e) {
        e.target.src = 'https://cdn.supersport.hr/IHG/default.jpg'
    }

    getData() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.casinoUtrkeIHGRepo.get(casino.config.casinoRestApiUrl, casino.config.casinoRestApiKey)]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    setData(data) {
        var [races] = data;
        this.setState({ races: races == null ? [] : races });
        this.props.showLoadingFn(false);
    }

    renderContent() {
        return <div>
            <div className="segment v2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.setState({ selectedTab: tab })} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.state.selectedTab === 'Moje utrke' && this.renderAktivneUtrke()}
            {this.state.selectedTab === 'Informacije' && this.renderInformacije()}
        </div>
    }

    renderInformacije() {
        return <div>
            <div className="cu-info">
                <div className="title">Što su SuperCasino utrke?</div>
                <p className="large">
                    Ne propusti fenomenalne nagrade, adrenalin i uzbuđenje u SuperCasino utrkama tijekom cijele godine!
                </p>
                <p>
                    Brzina povećava tvoje šanse za pobjedu - uključi se što prije u aktivnu utrku i prestigni konkurenciju. Raniji start može ti donijeti prednost, ali i ako kreneš kasnije, nagrade su ti i dalje dostižne. 🏆
                </p>
                <p className="bold">
                    Ovdje ćeš pronaći popis aktivnih i budućih utrka.
                </p>
                <p>
                    Stisni gas do daske i ubrzaj do pobjede!
                </p>
            </div>
            <div className="img-trophy"></div>
            <div className="divider"></div>
        </div>
    }

    renderAktivneUtrke() {
        return <div>
            <div className="title">Moje utrke</div>
            {this.state.races && this.state.races.map((race, index) => this.renderUtrka(race, index))}
            {this.state.races && this.state.races.length == 0 && <div>Trenutno nema aktivnih utrka za tebe.</div>}
        </div>
    }

    renderUtrka(race, index) {
        let imgUrl = race?.image + '?c=' + casino.config.guiCacheVerzija;
        const firstReward = race.rewards.find(x => x.rank == "1").value;
        return <div key={index}>
            <div className="race-item" >
                <div className="race-item-img">
                    <img src={imgUrl} onError={this.addDefaultSrc}></img>
                    {race.tournamentStatus == "Traje" && <span className="img-active"></span>}
                </div>
                <div className="race-item-info">
                    <div className="race-item-title">{race.tournamentName}</div>
                    <div className="race-item-title">Nagrada: <span className="red">{casino.utils.numberWithCurrencyFromated(race.rewardsSum, 'EUR')}</span></div>
                    <div className="race-item-duration">Trajanje:&nbsp;
                        <span className="red">
                            {casino.utils.dateToShortDateString(new Date(race.startTimeUTC))}. {casino.utils.dateToTimeString(new Date(race.startTimeUTC))}h - {casino.utils.dateToShortDateString(new Date(race.endTimeUTC))}. {casino.utils.dateToTimeString(new Date(race.endTimeUTC))}h
                        </span>
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: race.description }}></p>
                    <p>Igraj odabrane igre, skupljaj bodove i osvoji glavnu nagradu od <b>{casino.utils.numberWithCurrencyFromated(firstReward, 'EUR')}</b>.</p>
                    <NavLink to={'/casino-utrke/' + race.tournamentID} className="view-more-btn">
                        {race.tournamentStatus == "Traje" ? 'Uključi se' : 'Saznaj više'}
                    </NavLink>
                </div>
            </div>
            <div className="divider"></div>
        </div>
    }

    renderForAnonymousUser() {
        let raceId = sessionStorage.getItem('casino-utrka');
        let from = raceId ? this.props.route.location.pathname + "/" + raceId : this.props.route.location.pathname;
        return <div>
            <div className="title">Prijavi se kako bi vidio Aktivne utrke!</div>
            <div className="actions">
                {!casino.config.fromNativeApp && <NavLink onClick={() => sessionStorage.removeItem("casino-utrka")} to={{ pathname: this.props.getHomePathFn(this.props.route.location, '/login'), state: { from: from } }} className="login-btn">Prijava</NavLink>}
                {casino.config.fromNativeApp && <button className="login-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Prijavi se i zaigraj</button>}
                <button className="registration-btn" onClick={() => location.href = 'https://m.supersport.hr/registracija'}>Registracija</button>
            </div>
            <div className="divider"></div>
            {this.renderInformacije()}
        </div>
    }

    renderLoading() {
        return <div>
            <div className="rectangle-1 half left tab"></div>
            <div className="rectangle-1 half right tab"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-1"></div>
            <div className="rectangle-2"></div>
            <div className="rectangle-1 full"></div>
            <div className="rectangle-1 half left"></div>
            <div className="rectangle-1 half right red"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-3"></div>
        </div>
    }

    render() {
        return <div>
            <MetaTags title="Casino Utrke | Igraj Casino Igre i Osvoji Nagradu | SuperCasino | SuperCasino" description={"Ne propusti casino utrke tijekom cijele godine. Zaigraj omiljenu casino igru.  Uzbuđenje, zabava i nagrade su zagarantirane!"} />
            <Header key="header" {...this.state} {...this.props} disableBrowserBack={true}></Header>
            <div className="cu-header">
                <div className="content-container">
                    <div className="img"></div>
                    <div className="rive-container">
                        <RiveComponent
                            lazyLoad={true}
                            cacheBust={`c=${casino.config.guiCacheVerzija}`}
                            src={`${casino.config.casinoCDNImagesUrl}/Banners/CasinoUtrke/casinoutrke_v1_old.riv?v=2`}
                            stateMachines="State Machine 1"
                            useOffscreenRenderer={true}
                            playRequest={true}
                            disablePlayOutsideViewport={{ target: ".content-container", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                        />
                    </div>
                </div>
            </div>
            <div id="page-wrapper" className="no-padding grey">
                <div className="cu-container maximum margin-center" >
                    {this.props.user && !this.state.races && this.renderLoading()}
                    {this.props.user && this.state.races && this.renderContent()}
                    {!this.props.user && this.renderForAnonymousUser()}
                </div>
            </div>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
}